/**
 * CargaFotoCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {CargaFoto} from '@/model/resource/CargaFoto'

/* TODO: review generated class */
@HttpExclude()
export class CargaFotoCollection extends PageCollection<CargaFoto> {
  constructor() {
    super(CargaFoto)
  }

  queryAsPage() {
    return this.listCargaFoto()
  }

  async listCargaFoto() {
    return await Request.get(`/admin/carga-foto`, {params: this.params})
      .name('listCargaFoto')
      .as(this)
      .getResponse()
  }

  async listCsvCargaFoto() {
    return await Request.get(`/admin/carga-foto/csv`, {params: this.params})
      .name('listCsvCargaFoto')
      .as(this)
      .getResponse()
  }
}
